import { Component, inject } from '@angular/core';
import {ButtonComponent} from "@husbanken/designsystem-angular-core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'bko-lagre-pdf-card',
  imports: [
      ButtonComponent
  ],
  templateUrl: './lagre-pdf-card.html',
  styleUrl: './lagre-pdf-card.scss'
})
export class LagrePdfCard {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  id: string = this.route.snapshot.params.id;

  tilDelBoligkompass(): void {
    this.router.navigate(["/del-boligkompass", this.id]);
  }
}
